import { toQueryParams } from "utils/http/params";
import { dataApi } from "./DataService";
import { isoToDateString } from "utils/date";
import { getQueryCacheKey } from "rtkq/getQueryCacheKey";
import { patchQueries } from "rtkq/patchQueries";
import { markEndpointStale } from "rtkq/staleManager";

const licenceApi = dataApi
  .enhanceEndpoints({addTagTypes: ['licence']})
  .injectEndpoints({
    endpoints: (builder) => ({
      
      getLicences: builder.query({
        query: (arg) => ({
          url: '/licences',
          params: toQueryParams(arg)
        }),
        providesTags: ['licence']
      }),
      
      updateLicence: builder.mutation({
        query: ({id, body}) => ({
          url: `/licences/${encodeURIComponent(id)}`,
          method: 'PATCH',
          body: body
        }),

        async onQueryStarted( {id, body, currentQueryArgs}, {dispatch, queryFulfilled}) {
          
          const result = dispatch(
            licenceApi.util.updateQueryData('getLicences', currentQueryArgs, (draft) => {
              const item = draft?.body?.items.find(el => el.id === id);
              item && Object.assign(item, body);
            })
          );

          try {
            const { data } = await queryFulfilled;
            dispatch(
              licenceApi.util.updateQueryData('getLicences', currentQueryArgs, (draft) => {
                const item = draft?.body?.items.find(el => el.id === id);
                item && Object.assign(item, data.body/*, {
                  createdAt: isoToDateString(data.body.createdAt),
                  endActivationAt: isoToDateString(data.body.endActivationAt),
                  activatedAt: isoToDateString(data.body.activatedAt),
                  usedAt: isoToDateString(data.body.usedAt)
                }*/);
              })
            );
            
            
            //если есть фильтрация + изменяемое поле в body задействовано при фильтрации, то обновляем и текущий кэш
            const currentCacheKey = getQueryCacheKey({endpointName: 'getLicences', queryArgs: currentQueryArgs, patchData: body});
            dispatch(
                markEndpointStale({
                    endpointName: 'getLicences',
                    exceptCacheKey: currentCacheKey
                })
            );
          }
          catch {
            result.undo();
          }
        }  
      }), 

      createLicences: builder.mutation({
        query: ({body}) => ({
          url: `/licences`,
          method: 'POST',
          body: body
        })
      })
    })
  });

export const {
  useGetLicencesQuery,
  useUpdateLicenceMutation,
  useCreateLicencesMutation
} = licenceApi; 